import { DSTypes } from '../../../cimsPage/instances/ds'
import { Types } from '../../common'

const types = Types({
  page: DSTypes,
  create: 'F53C6073-6E72-4E48-BAC1-338245BFA540',
  view: '22883FD7-63A3-489C-BE52-4535140AACC2',
  edit: 'A35A4E99-FB7F-4EC5-A0DA-703E14944A2C',
  removeRestore: '30587340-6FBE-4D8E-BF16-9978B30D6FF8',
})

export const CreateDesignSubmittalType = types.Create
export const ViewDesignSubmittalType = types.View
export const EditDesignSubmittalType = types.Edit
export const RemoveRestoreDesignSubmittalType = types.RemoveRestore

export type DSTypePermission =
  | typeof CreateDesignSubmittalType
  | typeof ViewDesignSubmittalType
  | typeof EditDesignSubmittalType
  | typeof RemoveRestoreDesignSubmittalType
